export default {
    noPaper: "暂无试题",
    arrangementTime: "安排时间",
    tabEnd: "结束",
    tabVideo: "视频",
    tabPaper: "试题",
    videoStatus: {
        notStart: "未开始",
        connect: "可连接",
        interviewing: "视频中",
        hangup: "已挂断",
        ended: "已结束",
        checkIn: "已登录",
        online: "在线",
        offline: "离线",
    },
    fraud: "舞弊",
    fraudCancel: "取消舞弊标记",
    absent: "缺考",
    absentCancel: "取消缺考标记",
    groupName: "所属组",
    groupNumber: "编号",
    number: "{number}号",
    view: "查看",
    noDataMsg: "暂无评分表",
    yes: "是",
    placeholder: {
        reason: "请输入修改原因",
        old_score: "请输入原评分",
        new_score: "请输入修改后的评分",
    },
    fraudConfirmMsg: "标记舞弊后，候选人将不能被评分，成绩作废，确定标记？",
    fraudCancelMsg: "确认取消该候选人的舞弊标记？",
    absentConfirmMsg: "标记缺考后，候选人将不能被评分，成绩作废，确定标记？",
    absentCancelMsg: "确认取消该候选人的缺考标记？",
    signOutConfirmMsg: "确定退出面试评分系统？",
    signOutCancelMsg: "取消退出",
    interviewingAlertMsg: "当前选手暂未打分",
    scoreMsg: ["当前候选人的分数是", "结果", "您确定提交吗?"],
    scoreAlertMsg: "评分项“{msg}”未判分，请在所有评分项判分后提交面试结果",
    error307: "您已被管理员结束打分，点击确定后，将跳转到首页",
    error401: "登录过期，请重新登录",
    successMsg: {
        processing: "修改成绩申请中，请耐心等待",
        confirmed: "管理员已同意修改成绩申请",
        unconfirmed: "管理员已拒绝修改成绩申请",
        default: "出了一些问题",
    },
    applicationNotify: "申请状态提示",
    showHistoryNoData: "此候选人暂无历史成绩",
    videoOpreateStartAlert: "面试时间未到，请稍后...",
    videoOpreateEndAlert: "面试已结束，如有需要请联系管理员",
    btnContent: {
        waiting: "开始评分",
        interviewing: "完成",
        complete: "修改成绩",
        processing: "查看申请状态",
        confirmed: "修改成绩",
        unconfirmed: "修改成绩",
    },
    period: "。",
};
